export const addressScheduleId = '4';
export const paymentRequestId = '2757';
export const scheduleSBPIdLifePage1= '304';
export const scheduleSBPIdLifePage2 = '323';
export const scheduleSBPId = '2750'
